import { useSettingMigrateRetailerStore } from "@faire/retailer-visitor-shared/settings/useSettingMigrateRetailerStore";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";
import { create } from "zustand";

interface RetailerStatus {
  showR2B: boolean;
  reportedCreationTime: keyof typeof IRetailer.ReportedCreationTime | undefined;
  hasPlacedFirstOrder: boolean;
  setRetailerStatus: (retailer: Partial<IRetailer>) => void;
}

export const useZustandRetailerStatus = create<RetailerStatus>((set) => ({
  showR2B: false,
  reportedCreationTime: undefined,
  hasPlacedFirstOrder: false,
  setRetailerStatus: (retailer) => {
    set({
      showR2B: !retailer.hide_retailer2_maker,
      reportedCreationTime: retailer.reported_creation_time,
      hasPlacedFirstOrder: !!retailer.first_order_at,
    });
  },
}));

const useRetailerStatusControl = () => {
  const { showR2B, reportedCreationTime, hasPlacedFirstOrder } =
    useRetailerStore([
      "showR2B",
      "reportedCreationTime",
      "hasPlacedFirstOrder",
    ]);

  return {
    showR2B,
    reportedCreationTime,
    hasPlacedFirstOrder,
  };
};

export const useRetailerStatus = () => {
  const shouldUseHooksMigration = useSettingMigrateRetailerStore();
  if (shouldUseHooksMigration) {
    // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
    return useZustandRetailerStatus();
  }
  // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
  return useRetailerStatusControl();
};
